var _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#1a1a2e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960, 500)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 50,
    fill: "none",
    stroke: "#444",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 50,
    fill: "none",
    stroke: "#666",
    strokeWidth: 6,
    strokeDasharray: "78 235",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: 0,
    to: 360,
    dur: "1.5s",
    repeatCount: "indefinite"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 600,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#555",
    textAnchor: "middle"
  }, "Loading...")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBackground);
export default __webpack_public_path__ + "static/media/loading-background.0378f4bc58548b697661b522b9922454.svg";
export { ForwardRef as ReactComponent };